"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledIs = _interopRequireDefault(require("../../utils/styled-is"));
var _HBButtonGroup = require("./HBButtonGroup.styles");
var _HBTooltip = _interopRequireDefault(require("../HBTooltip/HBTooltip"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var _templateObject;
var HBButtonGroup = function HBButtonGroup(_ref) {
  var testIdName = _ref.testIdName,
    testId = _ref.testId,
    buttons = _ref.buttons,
    onChange = _ref.onChange,
    width = _ref.width,
    height = _ref.height,
    selectedButton = _ref.selectedButton,
    className = _ref.className,
    disabled = _ref.disabled,
    _ref$setIconOnTopOfTh = _ref.setIconOnTopOfTheText,
    setIconOnTopOfTheText = _ref$setIconOnTopOfTh === void 0 ? true : _ref$setIconOnTopOfTh,
    _ref$ignoreActiveStyl = _ref.ignoreActiveStyles,
    ignoreActiveStyles = _ref$ignoreActiveStyl === void 0 ? false : _ref$ignoreActiveStyl,
    _ref$isSingleLineText = _ref.isSingleLineText,
    isSingleLineText = _ref$isSingleLineText === void 0 ? false : _ref$isSingleLineText;
  var handleChange = function handleChange(e) {
    onChange(e.currentTarget.value);
  };
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName,
    suffix: 'button-group',
    componentName: 'HBButtonGroup',
    enforce: false
  });
  return /*#__PURE__*/_react["default"].createElement(_HBButtonGroup.ButtonGroup, {
    width: width,
    height: height,
    className: className,
    "data-testid": finalTestId,
    disabled: disabled
  }, buttons.map(function (button) {
    return /*#__PURE__*/_react["default"].createElement(ButtonContent, {
      key: button.value,
      button: button,
      handleChange: handleChange,
      selectedButton: selectedButton,
      setIconOnTopOfTheText: setIconOnTopOfTheText,
      ignoreActiveStyles: ignoreActiveStyles,
      isSingleLineText: isSingleLineText
    });
  }));
};
var _default = exports["default"] = HBButtonGroup;
var ButtonContent = function ButtonContent(_ref2) {
  var _button$tooltip, _button$tooltip2, _button$tooltip3, _button$tooltip4, _button$tooltip5, _button$tooltip6, _button$tooltip7;
  var button = _ref2.button,
    selectedButton = _ref2.selectedButton,
    handleChange = _ref2.handleChange,
    setIconOnTopOfTheText = _ref2.setIconOnTopOfTheText,
    ignoreActiveStyles = _ref2.ignoreActiveStyles,
    isSingleLineText = _ref2.isSingleLineText;
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: button.testId,
    identifier: button.testIdName,
    suffix: 'button-group-item',
    componentName: 'HBButtonGroup',
    enforce: false
  });
  var buttonDisabled = button.disabled;
  var commonButtonProps = {
    hasIcon: !!button.icon,
    disabled: button.tooltip ? false : buttonDisabled,
    key: button.value,
    active: button.value === selectedButton && !buttonDisabled,
    setIconOnTopOfTheText: setIconOnTopOfTheText,
    value: button.value,
    onClick: buttonDisabled ? function () {} : handleChange,
    type: 'button',
    'data-active': button.value === selectedButton,
    'data-testid': finalTestId
  };
  var buttonContent = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, button.icon && /*#__PURE__*/_react["default"].createElement(_HBButtonGroup.IconContainer, {
    active: button.value === selectedButton,
    ignoreActiveStyles: ignoreActiveStyles
  }, button.icon), /*#__PURE__*/_react["default"].createElement(_HBButtonGroup.ButtonLabel, {
    isSingleLineText: isSingleLineText
  }, button.label));
  return button.tooltip ? /*#__PURE__*/_react["default"].createElement(_HBTooltip["default"], {
    key: button.value,
    forceClose: !button.tooltip || (button === null || button === void 0 ? void 0 : button.tooltip.forceClose),
    placement: (_button$tooltip = button.tooltip) === null || _button$tooltip === void 0 ? void 0 : _button$tooltip.placement,
    offsetX: (_button$tooltip2 = button.tooltip) === null || _button$tooltip2 === void 0 ? void 0 : _button$tooltip2.offsetX,
    offsetY: (_button$tooltip3 = button.tooltip) === null || _button$tooltip3 === void 0 ? void 0 : _button$tooltip3.offsetY,
    keepOpenOnHover: (_button$tooltip4 = button.tooltip) === null || _button$tooltip4 === void 0 ? void 0 : _button$tooltip4.keepOpenOnHover,
    customStyle: (_button$tooltip5 = button.tooltip) === null || _button$tooltip5 === void 0 ? void 0 : _button$tooltip5.customStyle,
    targetContainerStyle: (_button$tooltip6 = button.tooltip) === null || _button$tooltip6 === void 0 ? void 0 : _button$tooltip6.targetContainerStyle,
    targetContainerClassName: button.value === selectedButton ? 'active' : '',
    target: /*#__PURE__*/_react["default"].createElement(ButtonWithTooltip, (0, _extends2["default"])({}, commonButtonProps, {
      disabledStyle: buttonDisabled
    }), buttonContent)
  }, (_button$tooltip7 = button.tooltip) === null || _button$tooltip7 === void 0 ? void 0 : _button$tooltip7.text) : /*#__PURE__*/_react["default"].createElement(_HBButtonGroup.Button, commonButtonProps, buttonContent);
};
var ButtonWithTooltip = (0, _styledComponents["default"])(_HBButtonGroup.Button).withConfig({
  displayName: "HBButtonGroup__ButtonWithTooltip",
  componentId: "sc-2s09cl-0"
})(["width:100%;", ";"], (0, _styledIs["default"])('disabledStyle')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n          background-color: ", " !important;\n          color: ", " !important;\n          cursor: not-allowed;\n    "])), _colors["default"].neutral100, _colors["default"].neutral600));
//# sourceMappingURL=HBButtonGroup.js.map